/* Splendido — Sigillo spinner: event delegation per .sp-img-loading
   Quando un <img> dentro un .sp-img-loading finisce di caricare,
   aggiunge .is-loaded al wrapper -> spinner fade out + img fade in.
   Funziona anche con immagini già in cache. */
(function () {
  function markLoaded(img) {
    var wrap = img.closest('.sp-img-loading');
    if (wrap && !wrap.classList.contains('is-loaded')) {
      wrap.classList.add('is-loaded');
    }
  }

  document.addEventListener('load', function (e) {
    if (e.target && e.target.tagName === 'IMG') markLoaded(e.target);
  }, true);

  function initScan() {
    var imgs = document.querySelectorAll('.sp-img-loading img');
    for (var i = 0; i < imgs.length; i++) {
      if (imgs[i].complete && imgs[i].naturalHeight !== 0) markLoaded(imgs[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initScan);
  } else {
    initScan();
  }
})();

/* Splendido — Video autoplay PULITO: nessuna chrome nativa di default.
   I controlli nativi appaiono solo su hover (desktop) o tap/click (mobile).
   Targeta i <video> dentro <video-media data-sp-clean-video> (autoplay). */
(function () {
  function bindAll() {
    var medias = document.querySelectorAll('video-media[data-sp-clean-video]');
    for (var i = 0; i < medias.length; i++) {
      var vm = medias[i];
      if (vm.__spCleanVideo) continue;
      vm.__spCleanVideo = true;
      var v = vm.querySelector('video');
      if (!v) continue;
      v.removeAttribute('controls'); // pulito all'avvio
      (function (vm, v) {
        vm.addEventListener('mouseenter', function () { v.setAttribute('controls', ''); });
        vm.addEventListener('mouseleave', function () { v.removeAttribute('controls'); });
        vm.addEventListener('click', function () { v.setAttribute('controls', ''); }, true);
        // Autoplay anche su DESKTOP (griglia): play quando il video è in vista, pause quando esce.
        // Prestige autoplaya solo lo slide attivo (mobile) -> in griglia non parte; qui lo garantiamo ovunque.
        v.muted = true; v.setAttribute('playsinline', '');
        if ('IntersectionObserver' in window) {
          var io = new IntersectionObserver(function (entries) {
            entries.forEach(function (e) {
              if (e.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
              else { v.pause(); }
            });
          }, { threshold: 0.35 });
          io.observe(v);
        }
      })(vm, v);
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindAll);
  } else {
    bindAll();
  }
  window.addEventListener('load', bindAll);
})();
